import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';


///
import { FormsModule } from '@angular/forms';

import { HttpModule } from '@angular/http';
import {  Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { FileService } from './file.service';


import { AppComponent } from './app.component';
///

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [HttpModule,
    BrowserModule,FormsModule
  ],
  providers: [FileService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts